import { useState } from 'react';
import { IProject } from '@/types/Project.model';
import { ProjectCard } from './ProjectCard';
import { ProjectModal } from './ProjectModal';
import classes from './ProjectList.module.css';

interface ProjectListProps {
  projects: IProject[];
  corporateColor: string;
  onDeleteProject: (projectId: string) => void;
  onLeaveProject: (projectId: string) => void;
  onUpdateProject: (updatedProject: IProject) => void;
  currentUserId: string;
}

export function ProjectList({
  projects,
  corporateColor,
  onDeleteProject,
  onLeaveProject,
  onUpdateProject,
  currentUserId,
}: ProjectListProps) {
  const [selectedProject, setSelectedProject] = useState<IProject | null>(null);
  const [modalOpened, setModalOpened] = useState(false);

  const handleProjectClick = (project: IProject) => {
    setSelectedProject(project);
    setModalOpened(true);
  };

  const handleModalClose = () => {
    setModalOpened(false);
    setSelectedProject(null);
  };

  const handleProjectUpdate = (updatedProject: IProject) => {
    // Update the main projects list
    onUpdateProject(updatedProject);
    // Also update the selected project in the modal
    setSelectedProject(updatedProject);
  };

  return (
    <>
      <div className={classes.grid}>
        {projects.map((project, index) => (
          <ProjectCard
            key={project._id || index}
            project={project}
            corporateColor={corporateColor}
            onClick={() => handleProjectClick(project)}
          />
        ))}
      </div>

      <ProjectModal
        project={selectedProject}
        opened={modalOpened}
        onClose={handleModalClose}
        onDelete={onDeleteProject}
        onLeave={onLeaveProject}
        onUpdate={handleProjectUpdate}
        corporateColor={corporateColor}
        currentUserId={currentUserId}
      />
    </>
  );
}
